<div class="sam-form-row">
   <label>{{ 'brick.brick_definitions.tab-brick.settings.tab_position' | translate }}</label>
   <kendo-dropdownlist
      [data]="tabBrickPositionPossibleValues"
      [value]="tabPosition$ | async"
      class="k-form-field sam-form-control-full"
      [valuePrimitive]="false"
      [valueField]="'value'"
      [textField]="'value'"
      (selectionChange)="changeTabPosition($event)"
   >
      <ng-template kendoDropDownListValueTemplate kendoDropDownListItemTemplate let-dataItem>
         {{ dataItem?.translationKey | translate }}
      </ng-template>
   </kendo-dropdownlist>
</div>

<div class="sam-form-row">
   <label>{{ 'brick.brick_definitions.tab-brick.settings.tab_presentation_type' | translate }}</label>
   <kendo-dropdownlist
      [data]="tabPresentationTypePossibleValues"
      [value]="tabPresentationType$ | async"
      class="k-form-field sam-form-control-full"
      [valuePrimitive]="false"
      [valueField]="'value'"
      [textField]="'value'"
      (selectionChange)="changeTabPresentationType($event)"
   >
      <ng-template kendoDropDownListValueTemplate kendoDropDownListItemTemplate let-dataItem>
         {{ dataItem?.translationKey | translate }}
      </ng-template>
   </kendo-dropdownlist>
</div>

<div class="sam-form-row sam-no-margin">
   <label>{{ 'brick.brick_definitions.tab-brick.settings.tabs' | translate }}</label>
   <div fxLayout="column">
      <div fxLayout="row">
         <button
            (click)="toggleBrickSelectionDialog()"
            kendoTooltip
            [tooltipTemplate]="brickSelectionDialog"
            tooltipClass="tooltip-popup"
            #brickSelectionPopupControl
            #brickSelectionTooltipDirective="kendoTooltip"
            kendoButton
            showOn="none"
         >
            <fa-icon class="sam-margin-right" [icon]="addTabIcon"></fa-icon>
            <div class="sam-button-text">
               {{ 'brick.brick_definitions.tab-brick.settings.add_new_tab_button' | translate }}
            </div>
         </button>
      </div>

      <div class="scrollable" cdkDropList [cdkDropListData]="tabIds$ | async" (cdkDropListDropped)="onDrop($event)">
         <ng-container *ngIf="(tabIds$ | async)?.length > 0; else emptyList">
            <kendo-panelbar fxFlex="1 1 100%" class="sam-panelbar-item">
               <kendo-panelbar-item title="" *ngFor="let item of tabIds$ | async">
                  <ng-template kendoPanelBarItemTitle>
                     <div class="sam-full-width sam-center" fxLayout="row">
                        <samweb-tab-item-setting
                           [brickInstanceId]="brickInstanceId"
                           [tabId]="item"
                           [collapsed]="true"
                        ></samweb-tab-item-setting>
                     </div>
                  </ng-template>
                  <ng-template kendoPanelBarContent>
                     <div>
                        <samweb-tab-item-setting
                           class="expanded-item"
                           [brickInstanceId]="brickInstanceId"
                           [tabId]="item"
                        ></samweb-tab-item-setting>
                     </div>
                  </ng-template>
               </kendo-panelbar-item>
            </kendo-panelbar>
         </ng-container>
         <ng-template #emptyList>
            <div>{{ 'brick.brick_definitions.tab-brick.no_tabs_added' | translate }}</div>
         </ng-template>
      </div>
   </div>
</div>

<ng-template #brickSelectionDialog>
   <samweb-add-brick-dialog
      [addingBrickSpecialHandlingByOtherBrickInstanceId]="brickInstanceId"
      (samwebOutsideClick)="closeBrickSelectionDialog()"
   ></samweb-add-brick-dialog>
</ng-template>
